<template>
  <div>
    <v-btn
      v-if="circle"
      outline
      :loading="loading"
      :disabled="loading"
      small
      fab
      color="primary"
      @click="getShopProfile"
      v-tooltip.top="$t('Print Cover')"
    >
      <span class="fa fa-print"></span>
    </v-btn>
    <v-btn
      v-else
      :loading="loading"
      :disabled="loading || orders.length == 0"
      outline
      color="grey"
      @click="getShopProfile"
    >
      <v-icon>fa fa-print</v-icon>
      &nbsp;{{ $t('Print Covers') }}
    </v-btn>
    <v-dialog v-model="showEditAddress" width="500">
      <v-card v-if="showEditAddress">
        <v-card-text>
          <div style="text-align: right">
            <v-btn @click="cancelEdit" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div class="row">
            <!-- <div class="title">แก้ไขที่อยู่ร้านค้า</div> -->
            <div class="col s12">
              <label for="pageAddress">{{ $t('Shop Address') }}</label>
            </div>
            <div class="col s12 form-control">
              <div>
                <!-- <tooltip v-model="showSaveAddress">Saved</tooltip> -->
                <textarea
                  v-model="input.pageaddress"
                  class="form-control"
                  rows="5"
                  style="resize: vertical"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row text-xs-center">
            <div class="col s12">
              <v-btn @click="skipEdit" outline color="grey">{{ $t('skip') }}</v-btn>
              <v-btn @click="saveContent" :loading="loadingsave" depressed color="primary">
                {{ $t('Save') }}
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import { shipping } from './shippingbase64.js'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf',
  },
}

export default {
  props: ['orders', 'circle'],
  data() {
    return {
      profile: '',
      loading: false,
      loadingsave: false,
      showEditAddress: false,
      input: {
        pageaddress: '',
      },
    }
  },
  computed: {
    ...mapGetters(['selectedBot', 'getPageProfile']),
  },
  mounted() {},
  methods: {
    saveContent() {
      let vm = this
      vm.loadingsave = true
      api.editShopProfile(
        { ...this.getPageProfile, pageaddress: this.input.pageaddress },
        function (error, response) {
          vm.loadingsave = false

          if (error) {
            console.error(error)
            return
          }
          vm.$store.state.pageProfile.pageaddress = vm.input.pageaddress
          vm.getShopProfile()
          vm.showEditAddress = false
        }
      )
    },
    cancelEdit() {
      this.showEditAddress = false
      this.input.pageaddress = ''
    },
    skipEdit() {
      this.showEditAddress = false
      this.input.pageaddress = ''
      this.getShopProfile()
    },
    clickPrintPdf() {
      if (this.getPageProfile.pageaddress) {
        this.getShopProfile()
      } else {
        this.showEditAddress = true
      }
    },
    getShopProfile: function () {
      let vm = this
      vm.loading = true
      if (!vm.selectedBot.pageid || vm.selectedBot.pageid == null) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid,
      }
      let auth = null
      api.getShopProfile(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        // console.log(response)
        if (response.shopprofile) {
          vm.profile = response.shopprofile
          try {
            vm.profile.companyname = JSON.parse(response.shopprofile.description).companyname
            vm.profile.phoneno = JSON.parse(response.shopprofile.description).phoneno
          } catch (error) {
            vm.profile.companyname = ''
            vm.profile.phoneno = ''
          }
          // console.log(vm.profile)
          // console.log(response.shopprofile.descriptio)
          vm.$emit('onPrinCover', {
            printPdf: function (orders) {
              vm.printPDF(orders)
            },
          })
        }
      })
    },
    async myShippingImg() {
      // var shipping = {
      //   flash_charge: '',
      //   additionalproduct_charge: '',
      //   nim_charge: '',
      //   ninjavan_charge: '',
      //   jtexpress_charge: '',
      //   lalamove_charge: '',
      //   cjlogistics_charge: '',
      //   nikos_charge: '',
      //   scgexpress_charge: '',
      //   skootar_charge: '',
      //   alphaexpress_charge: '',
      //   deliveree_charge: '',
      //   grab_charge: '',
      //   lineman_charge: '',
      //   tnt_charge: '',
      //   cod_charge: '',
      //   normal_charge: '',
      //   ems_charge: '',
      //   kerry_charge: '',
      //   bestexpress_charge: '',
      //   interexpress_charge: '',
      //   dhl_charge: '',
      //   other_charge: '',
      //   other2_charge: '',
      //   other3_charge: '',
      //   other4_charge: '',
      //   other5_charge: ''
      // }
      // return new Promise(async (resolve, reject) => {
      //   for (var item in shipping) {
      //     shipping[item] = await this.getBase64Image(
      //       'https://' +
      //         window.location.host +
      //         '/static/img/assets/payment/mini/' +
      //         (item.includes('other') ? 'other_charge' : item) +
      //         '_logo.jpg'
      //     )
      //   }
      //   return resolve(shipping)
      // })

      return Promise.resolve(shipping)
    },
    getBase64Image(url) {
      return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        xhr.onload = function () {
          var reader = new FileReader()
          reader.onloadend = function () {
            resolve(reader.result)
          }
          reader.readAsDataURL(xhr.response)
        }
        xhr.onerror = function (e) {
          reject(e)
        }
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.send()
      })
    },
    async printPDF(orders) {
      var shippinglist = this.$store.state.shippinglist
      var shippingtypeimg = await this.myShippingImg()
      var vm = this
      var regularsize = 14
      var headersize = 16
      var data = orders.map((el, i) => {
        var productdetail
        var qrimage = {}
        if (el.note && el.note.includes('base64,')) {
          qrimage = {
            margin: [0, 20, 0, 0],
            image: el.note,
            width: 70,
            alignment: 'right',
          }
        } else {
          qrimage = {
            text: '',
            width: 0,
          }
        }
        var payment = vm.$t('Credit card')

        if (el.payment == 'banktransfer' || el.payment == 'transfer') {
          payment = vm.$t('Bank Transfer')
        } else if (el.payment == 'qrcode') {
          payment = 'Qr Code'
        } else if (el.payment == 'fbpay') {
          payment = vm.$t('Mobile Banking')
        } else if (el.payment == 'cod') {
          payment = vm.$t('cod_charge')
        }
        try {
          productdetail = JSON.parse(el.productdetail)
        } catch (error) {
          productdetail = []
        }
        return [
          {
            // width: 225,
            table: {
              widths: ['*'],
              heights: [60],
              body: [
                [
                  {
                    text: [
                      { text: vm.$t('Sender') + '\n', style: 'header' },
                      {
                        text: `${vm.profile.companyname ? vm.profile.companyname + ', ' : ''}${
                          vm.profile.phoneno ? 'Tel. ' + vm.profile.phoneno + ', ' : ''
                        } ${vm.noSpaceAndSpecial(vm.profile.pageaddress, true)}`,
                        style: 'paragraph',
                        bold: true,
                      },
                    ],
                    style: 'container',
                    lineHeight: 1,
                  },
                ],
              ],
            },
          },
          {
            margin: [0, 6, 0, 0],
            table: {
              widths: ['*'],
              heights: [60],
              body: [
                [
                  {
                    text: [
                      { text: vm.$t('Receiver') + '\n', style: 'header' },
                      {
                        text: vm.noSpaceAndSpecial(el.nameaddress, true),
                        style: 'paragraph',
                        bold: true,
                      },
                    ],
                    style: 'container',
                  },
                ],
              ],
            },
          },
          // {
          //   table: {
          //     widths: ['*'],
          //     heights: [1],
          //     body: [[' '], [' ']]
          //   },
          //   // margin: [0, 0, 0, 0],
          //   layout: {
          //     hLineWidth: function(i, node) {
          //       return i === 0 || i === node.table.body.length ? 0 : 0.1
          //     },
          //     vLineWidth: function(i, node) {
          //       return 0
          //     },
          //     hLineColor: function(i, node) {
          //       return i === 0 || i === node.table.body.length ? '' : '#bcbcbc'
          //     }
          //   }
          // },
          {
            columns: [
              {
                width: 320,
                stack: [
                  {
                    text: vm.$t('Receipt'),
                    style: 'receipt',
                  },
                  {
                    table: {
                      widths: [140, 150],
                      lineHeight: 0.5,
                      body: [
                        [
                          vm.$t('Order Date'),
                          {
                            text: moment(el.timestamp).format('DD/MM/YYYY'),
                            style: { alignment: 'right' },
                          },
                        ],
                        [vm.$t('Order No.'), { text: el.id, style: { alignment: 'right' } }],
                        [
                          vm.$t('Shipping option'),
                          { text: vm.$t(el.shippingtype), style: { alignment: 'right' } },
                        ],
                        [
                          vm.$t('Payment Method'),
                          {
                            text: payment + ' - ' + vm.$t(el.transactionid),
                            style: { alignment: 'right' },
                          },
                        ],
                      ],
                    },
                    layout: {
                      hLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineWidth: function (i, node) {
                        return 0
                      },
                      hLineWidth: function (i, node) {
                        return 0
                      },
                    },
                  },
                  {
                    table: {
                      widths: [140, 150],
                      body: [
                        [
                          {
                            text: vm.$t('Shipping option'),
                            style: { fontSize: regularsize },
                            bold: true,
                          },
                          {
                            columns: [
                              {
                                text: vm.$t(
                                  el.shippingtype.includes('other')
                                    ? shippinglist[el.shippingtype][4]
                                    : el.shippingtype
                                ),
                                width: '*',
                                style: { alignment: 'right', fontSize: regularsize },
                                margin: [0, 0, 10, 0],
                                bold: true,
                              },
                              {
                                image: shippingtypeimg[el.shippingtype]
                                  ? shippingtypeimg[el.shippingtype]
                                  : shippingtypeimg['other_charge'],
                                width: 30,
                                style: { alignment: 'right', fontSize: regularsize - 3 },
                              },
                            ],
                          },
                        ],
                        [
                          {
                            text: vm.$t('Payment Method'),
                            style: { fontSize: regularsize },
                            bold: true,
                          },
                          {
                            text: payment,
                            style: { alignment: 'right', fontSize: regularsize },
                            bold: true,
                          },
                        ],
                        [
                          { text: vm.$t('Remark'), style: { fontSize: regularsize }, bold: true },
                          {
                            text: el.remark,
                            style: { alignment: 'right', fontSize: regularsize },
                            bold: true,
                          },
                        ],
                      ],
                    },
                    layout: {
                      hLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineWidth: function (i, node) {
                        return 0
                      },
                      hLineWidth: function (i, node) {
                        return 0
                      },
                    },
                  },
                  {
                    text: vm.$t('Product Detail'),
                    margin: [0, 5, 0, 2],
                    style: {
                      bold: true,
                      fontSize: headersize,
                    },
                  },
                  {
                    table: {
                      widths: [370],
                      body: !productdetail.length
                        ? [{ text: el.productdetail }]
                        : productdetail.map((val, i) => {
                            return [
                              {
                                text: val.name + ` x ${val.quantity} (${val.option})`,
                                style: { fontSize: regularsize },
                                bold: true,
                              },
                            ]
                          }),
                    },
                    layout: {
                      hLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                      vLineColor: function (i, node) {
                        return i === 0 || i === node.table.body.length ? '#bcbcbc' : '#bcbcbc'
                      },
                    },
                    pageBreak: i + 1 == orders.length || el.payment == 'cod' ? '' : 'after',
                  },
                  ...(el.payment != 'cod'
                    ? []
                    : [
                        {
                          pageBreak: i + 1 == orders.length ? '' : 'after',
                          margin: [0, 10, 0, 0],
                          table: {
                            widths: [200 + 175],
                            body: [
                              // [vm.$t('Subtotal') + ':', { text: '฿' + el.total, style: { alignment: 'right' } }],
                              [
                                // { text: , style: { fontSize: regularsize } },
                                {
                                  text: vm.$t('Total price') + ': ' + '฿' + el.amount,
                                  style: { alignment: 'right', fontSize: regularsize + 2 },
                                  bold: true,
                                },
                              ],
                            ],
                          },
                          layout: {
                            vLineWidth: function (i, node) {
                              return 0
                            },
                            hLineWidth: function (i, node) {
                              return 0
                            },
                          },
                        },
                      ]),
                ],
              },
              {
                ...qrimage,
              },
            ],
          },
        ]
      })

      var dd = {
        content: [data],
        pageSize: 'A5',
        pageMargins: [15, 15, 15, 15],
        styles: {
          header: {
            fontSize: headersize,
            color: '#ff5656',
            bold: true,
          },
          paragraph: {
            fontWeight: 200,
            fontSize: regularsize,
          },
          container: {
            margin: [2, 2, 2, 2],
          },
          receipt: {
            fontSize: headersize,
            color: '#ff5656',
            bold: true,
          },
        },
        defaultStyle: {
          font: 'THSarabunNew',
        },
      }
      vm.loading = false
      pdfMake.createPdf(dd).open()
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintAllCoversCentral.vue